import { setAnalyticsOptOut } from '@wmgone/analytics';

import type { User } from '~/modules/auth';

// List of email addresses to opt out of Amplitude tracking.
const ANALYTICS_EXCLUDED_ACCOUNT_EMAILS: Lowercase<string>[] = [
  'oktatest_wmgone1@music.wmgis.com',
];

/**
 * Checks the user's email against the list of emails for which we don't want
 * to track analytics events. If the user's email is in the list, it opts out
 * of analytics tracking.
 * @param user - The user object to check.
 */
export function checkUserForOptOut(user: User) {
  if (
    ANALYTICS_EXCLUDED_ACCOUNT_EMAILS.includes(
      user.email.toLowerCase() as Lowercase<string>,
    )
  ) {
    setAnalyticsOptOut(true);
  }
}
